<ng-container *transloco="let t">
  @if (mobileSidebarOpen()) {
  <div
    class="sidebar-backdrop"
    (click)="closeMobileSidebar()"
    tabindex="0"
    role="button"
    (keydown.enter)="closeMobileSidebar()"
    (keydown.space)="closeMobileSidebar()"
  ></div>
  }
  <aside
    class="sidebar"
    [class.sidebar-visible]="mobileSidebarOpen()"
    [class.sidebar-collapsed]="desktopSidebarCollapsed()"
    role="navigation"
  >
    <div class="sidebar-brand">
      <a
        routerLink="/dashboard"
        class="sidebar-brand-link"
        (click)="closeMobileSidebar()"
      >
        <img
          src="/assets/logo-light.png"
          [alt]="t('layout.header.logoAlt')"
          class="sidebar-logo"
          [class.sidebar-logo-collapsed]="desktopSidebarCollapsed()"
        />
      </a>

      <button
        class="sidebar-brand-action"
        type="button"
        [attr.aria-label]="
          desktopSidebarCollapsed()
            ? t('layout.sidebar.expand')
            : t('layout.sidebar.collapse')
        "
        (click)="toggleDesktopSidebar()"
      >
        <i class="fas fa-ellipsis"></i>
      </button>
    </div>

    <div class="sidebar-scroll">
      <ul class="sidebar-menu">
        @for (item of primaryItems; track item.key) {
        <li>
          @if (item.children?.length) {
          <button
            type="button"
            class="sidebar-menu-item sidebar-menu-button"
            [class.active]="isGroupExpanded(item)"
            (click)="toggleGroup(item)"
          >
            <span class="sidebar-menu-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-menu-text">{{ t(item.key) }}</span>
            <span
              class="sidebar-menu-chevron"
              [class.sidebar-menu-chevron-open]="isGroupExpanded(item)"
            >
              <i class="fas fa-chevron-down"></i>
            </span>
          </button>

          @if (isGroupExpanded(item)) {
          <ul class="sidebar-submenu">
            @for (child of item.children; track child.key) {
            <li>
              <a
                [routerLink]="child.route"
                [queryParams]="child.queryParams"
                class="sidebar-menu-item sidebar-submenu-item"
                routerLinkActive="active"
                (click)="closeMobileSidebar()"
              >
                <span class="sidebar-menu-icon"
                  ><i [class]="child.icon"></i
                ></span>
                <span class="sidebar-menu-text">{{ t(child.key) }}</span>
              </a>
            </li>
            }
          </ul>
          } } @else {
          <a
            [routerLink]="item.route"
            [queryParams]="item.queryParams"
            class="sidebar-menu-item"
            routerLinkActive="active"
            (click)="closeMobileSidebar()"
          >
            <span class="sidebar-menu-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-menu-text">{{ t(item.key) }}</span>
            @if (item.showChevron) {
            <span class="sidebar-menu-chevron"
              ><i class="fas fa-chevron-down"></i
            ></span>
            }
          </a>
          }
        </li>
        }
      </ul>

      <div class="sidebar-divider"></div>

      <ul class="sidebar-menu">
        @for (item of secondaryItems; track item.key) {
        <li>
          <a
            [routerLink]="item.route"
            class="sidebar-menu-item"
            routerLinkActive="active"
            (click)="closeMobileSidebar()"
          >
            <span class="sidebar-menu-icon"><i [class]="item.icon"></i></span>
            <span class="sidebar-menu-text">{{ t(item.key) }}</span>
          </a>
        </li>
        }
      </ul>
    </div>

    <div class="sidebar-footer">
      <a
        class="sidebar-premium-btn"
        [routerLink]="['/coming-soon', 'manage-plan']"
        (click)="closeMobileSidebar()"
      >
        {{ t('layout.sidebar.getPremium') }}
      </a>
    </div>
  </aside>
</ng-container>
